import { Section, TableOfContent } from '../../../typings/interfaces';
import { GERMAN } from '../../../assets/images';
// German
const DESection: Section[] = [
  {
    name: '1: Hinweise und Übersicht',
    subSections: [
      {
        name: 'Vorwort',
        page: 3,
      },
      {
        name: 'Zweck und Anwendungsgebiete der praktischen Anleitung',
        page: 4,
      },
      {
        name: 'Wichtige Definitionen',
        page: 5,
      },
      {
        name: 'Hierarchie der Schutzmaßnahmen',
        page: 6,
      },
    ],
  },
  {
    name: '2: LIFEsaver',
    subSections: [
      {
        name: 'Kraftfahrzeug – Verkehrssicherheit',
        page: 9,
      },
      {
        name: 'Arbeiten in der Höhe',
        page: 12,
      },
      {
        name: 'FlurFörderzeuge & Mobile Arbeitsmaschinen',
        page: 18,
      },
      {
        name: 'Lockout Tagout/Energieabschaltung',
        page: 22,
      },
      {
        name: 'Arbeit an elektrischen Anlagen',
        page: 25,
      },
      {
        name: 'Arbeiten in beengten Räumen',
        page: 29,
      },
      {
        name: 'Schüttgut und Lagerung',
        page: 32,
      },
      {
        name: 'Sicherheit von Schienenfahrzeugen',
        page: 37,
      },
      {
        name: 'Aushub- und Grabenarbeiten',
        page: 41,
      },
      {
        name: 'Hub- & Anschlagarbeiten',
        page: 45,
      },
      {
        name: 'Gefahrstoffe',
        page: 49,
      },
      {
        name: 'Heißarbeiten',
        page: 52,
      },
    ],
  },
  {
    name: '3: Weitere Ressourcen und Tools',
    subSections: [
      {
        name: `Arbeit über und in der Nähe von Wasser`,
        page: 56,
      },
      {
        name: 'Herunterfallende Gegenstände',
        page: 59,
      },
      {
        name: 'Atmosphärische Prüfungen/Gastests',
        page: 61,
      },
      {
        name: 'Kommunikation bei chemischen Gefahren',
        page: 65,
      },
    ],
  },
  {
    name: '4: Sicherheitsmanagementverfahren von Cargill',
    subSections: [
      {
        name: 'Wichtige Begriffe',
        page: 70,
      },
      {
        name: 'Schwere und tödliche Verletzungen (SIF)',
        page: 72,
      },
      {
        name: 'Kategorisierung des Potenzials schwerer und tödlicher Verletzungen (SIFp)',
        page: 73,
      },
      {
        name: 'Tabelle der Kriterien für die automatische SIF-Bestimmung',
        page: 74,
      },
      {
        name: 'Leistung von Mitarbeitern und Unternehmen (Human and Organizational Performance – HOP)',
        page: 76,
      },
    ],
  },
];
const DETableofContent: TableOfContent = {
  language: 'de',
  sections: DESection,
  label: 'Inhaltsverzeichnis',
  pdfLink: 'https://en-pdfs-life-on-focus.dev.cglcloud.in/Cargill Field Safety Guide GERMAN(de_DE)_DIGITAL_CROPPED.pdf',
  hopPocket: 'HOP-Taschenführe',
  hopPocketLink: 'https://en-pdfs-life-on-focus.dev.cglcloud.in/HOP pocket guide content 2021-09-08_German.pdf',
  source: GERMAN,
};

export default DETableofContent;
